/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module CportalModule */

import {
    Component,
    Input,
    OnInit,
} from '@angular/core';

import { IExtendedALBServicesConfig } from 'ajs/modules/cportal';
import { L10nService } from '@vmw/ngx-vip';
import { LicensingService } from 'ajs/modules/licensing/services/licensing.service';
import { Subject, takeUntil } from 'rxjs';

import './cportal-info-preview.component.less';
import { CPortalPageStore } from '../../cportal-page';
import * as l10n from './cportal-info-preview.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 * Component to show the custom Fields on cPortal info full modal preview.
 * @author Ratan Kumar, Deepak Chaudhary
 */
@Component({
    selector: 'cportal-info-preview',
    templateUrl: './cportal-info-preview.component.html',
})
export class CPortalInfoPreviewComponent implements OnInit {
    /**
     * ALB Services Config.
     */
    @Input()
    public config: IExtendedALBServicesConfig;

    /**
     * Flag that tells if editable is an item or a message item.
     */
    @Input()
    public readonly isItem!: boolean;

    /**
     * Holds value of Site ID from License Service.
     */
    public siteId = '';

    /**
     * Get keys from source bundles for template usage.
     */
    public readonly l10nKeys = l10nKeys;

    /**
     * Subject used to unsubscribe observables.
     */
    private readonly ngDestroyed$ = new Subject();

    constructor(
        public l10nService: L10nService,
        private readonly licensingService: LicensingService,
        private readonly cPortalPageStore: CPortalPageStore,
    ) {
        this.l10nService.registerSourceBundles(dictionary);
    }

    /** @override */
    public ngOnInit(): void {
        this.cPortalPageStore.siteId$
            .pipe(takeUntil(this.ngDestroyed$))
            .subscribe((siteId: string) => {
                this.siteId = siteId;
            });
    }

    /** @override */
    public ngOnDestroy(): void {
        this.ngDestroyed$.next(true);
        this.ngDestroyed$.complete();
    }
}
